import { getAuthService } from '../services/authService';
import { ADMIN, SUBUSER, USER } from '../types/role.types';

/* eslint-disable import/prefer-default-export */
export function getHomePageForRole(role) {
    switch (role) {
        case ADMIN:
            return { name: 'account-list' };
        case USER:
        case SUBUSER:
            return { name: 'tab2' };
        default:
            return { name: 'mainPage' };
    }
}

/* eslint-disable import/prefer-default-export */
export async function limitView(router, allowedRoles) {
    const role = await getAuthService().getRole();

    if (!allowedRoles.includes(role)) {
        router.push(getHomePageForRole(role));
        return true;
    }

    return false;
}
